
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sa/speakers/profile/[slug]",
      function () {
        return require("private-next-pages/sa/speakers/profile/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sa/speakers/profile/[slug]"])
      });
    }
  